// extracted by mini-css-extract-plugin
export default {"home":"_1-BFLlg_EYJm_xqLyRKutg","image":"_2avoLfgX0gQU9RljqNNO7s"};